export const toDate = (month: string, year: string) => {
    return new Date(`${month} 2, ${year}`);
};

export const currentYear = () => new Date().getFullYear();
